import { TOB_HOST, TOC_HOST } from '../../../../config';
import { MessageIframe } from '../../../message-type/message-iframe';
var DOCS_ORIGIN = TOC_HOST;
var WEWORK_DOCS_ORIGIN = TOB_HOST;
var WEWORK_LOGIN_MESSAGE = 'login wework success';
var IFRAME_DOM_MOUNTED = 'IFRAME_DOM_MOUNTED';
var WeworkLoginMessage = /** @class */ (function () {
    function WeworkLoginMessage() {
        this.envType = 'person';
        this.getWeworkLoginMessage = new MessageIframe(this.getWeworkLoginMessageCheckFn);
    }
    WeworkLoginMessage.prototype.connect = function (type) {
        if (type) {
            this.envType = type;
        }
        this.getWeworkLoginMessage.connect();
    };
    WeworkLoginMessage.prototype.dispose = function () {
        this.weworkIframeMountListener = undefined;
        this.getWeworkLoginMessage.dispose();
    };
    WeworkLoginMessage.prototype.getWeworkLoginSuccessMessage = function (listener) {
        this.getWeworkLoginMessage.receive(listener);
    };
    WeworkLoginMessage.prototype.getWeworkIframeMessage = function (listener) {
        this.weworkIframeMountListener = listener;
    };
    WeworkLoginMessage.prototype.createWeworkLoginIframe = function (dom, src) {
        var _this = this;
        var iframe = document.createElement('iframe');
        iframe.src = src;
        iframe.frameBorder = '0';
        iframe.scrolling = 'auto';
        iframe.width = '100%';
        iframe.height = '100%';
        iframe.id = 'login_frame';
        iframe.name = 'login_frame';
        iframe.onload = function () {
            var _a;
            (_a = _this.weworkIframeMountListener) === null || _a === void 0 ? void 0 : _a.call(_this, new MessageEvent(IFRAME_DOM_MOUNTED));
        };
        dom.appendChild(iframe);
        return iframe;
    };
    WeworkLoginMessage.prototype.getWeworkLoginMessageCheckFn = function (message) {
        var data = message.data, origin = message.origin;
        var checkOrigin = this.envType === 'person' ? DOCS_ORIGIN : WEWORK_DOCS_ORIGIN;
        if (origin.indexOf(checkOrigin) && typeof data === 'string' && data.includes(WEWORK_LOGIN_MESSAGE)) {
            return true;
        }
        return false;
    };
    return WeworkLoginMessage;
}());
export { WeworkLoginMessage };
